import React from 'react';
import { useUser, useUserSubscriptions, useDetectIncognitoMode } from '@benzinga/user-context';
import { TrackingManager } from '@benzinga/tracking-manager';
import { PageProps } from '../Page';
import { Session } from '@benzinga/session';

interface Props {
  pageProps: Omit<PageProps, 'children'>;
  session: Session;
}

export const GlobalTracking: React.FC<Props> = ({ pageProps, session }) => {
  const user = useUser();
  const subscriptions = useUserSubscriptions();
  const isIncognito = useDetectIncognitoMode();

  React.useEffect(() => {
    session?.getManager(TrackingManager).setUser(user);
  }, [session, user]);

  React.useEffect(() => {
    session?.getManager(TrackingManager).setSubscriptions(subscriptions);
  }, [session, subscriptions]);

  React.useEffect(() => {
    session?.getManager(TrackingManager).setMeta(pageProps?.metaProps || null);
  }, [session, pageProps?.metaProps]);

  React.useEffect(() => {
    session?.getManager(TrackingManager).updateContext({ isIncognito: isIncognito });
  }, [session, isIncognito]);

  return null;
};
